import {LOGIN_FAIL, LOGIN_OK, LOGOUT} from './actionTypes';
import {push} from 'connected-react-router';
import {fetchJson} from '../util/fetch';

export const login = (email, password) => {
  return (dispatch, getState) => {
    const state = getState();
    return fetch('/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': state.app.csrfToken
      },
      body: JSON.stringify({
        email, password
      })
    }).then((response) => {
      if (response.ok) {
        dispatch({
          type: LOGIN_OK
        });
        if (state.activeStore && state.activeStore.activeStore) {
          return dispatch(push('/edit'));
        }
        return dispatch(push('/'));
      } else {
        return dispatch({
          type: LOGIN_FAIL
        });
      }
    }).catch(() => {
      return dispatch({
        type: LOGIN_FAIL
      });
    });
  }
};

export const getLogin = () => {
  return dispatch => {
    return fetchJson(dispatch, '/api/auth', undefined, {
      '403': () => {
        dispatch(push('/login'));
      }
    }).then(resp => {
      if (resp.ok) {
        dispatch({
          type: LOGIN_OK
        });
      }
    });
  };
};

export const logout = () => {
  return dispatch => {
    return fetchJson(dispatch, '/api/auth', {
      method: 'DELETE'
    }).then(resp => {
      if (resp.ok) {
        dispatch({
          type: LOGOUT
        });
        dispatch(push('/login'));
      }
    });
  };
};


// WEBPACK FOOTER //
// ./src/store/loginActions.js